__turbopack_context__.v({
  "descriptionAndProjectsContainer": "FundraisingEventPageContent-module__ruIVQq__descriptionAndProjectsContainer",
  "feppContentContainer": "FundraisingEventPageContent-module__ruIVQq__feppContentContainer",
  "verticalLine": "FundraisingEventPageContent-module__ruIVQq__verticalLine",
});
